module.exports = __webpack_public_path__ + "img/question-gray.bc0ad72.svg";